module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ändra egenskapsgrupp")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "GroupName",
      "label": "Namn"
    },
    model: {
      value: (_vm.g.name),
      callback: function($$v) {
        _vm.$set(_vm.g, "name", $$v)
      },
      expression: "g.name"
    }
  })], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-212c2737","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dialog/PropertyGroupEdit.vue
// module id = 507
// module chunks = 1